var exports = {
  "j": "errorBanner__xxiwFa",
};

module.exports = exports;
